import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.6569 5.34315C19.0474 5.73367 19.0474 6.36684 18.6569 6.75736L13.4142 12L18.6569 17.2426C19.0474 17.6332 19.0474 18.2663 18.6569 18.6569C18.2663 19.0474 17.6332 19.0474 17.2427 18.6569L12 13.4142L6.75737 18.6569C6.36684 19.0474 5.73368 19.0474 5.34316 18.6569C4.95263 18.2663 4.95263 17.6332 5.34316 17.2426L10.5858 12L5.34316 6.75736C4.95263 6.36684 4.95263 5.73367 5.34316 5.34315C5.73368 4.95262 6.36685 4.95262 6.75737 5.34315L12 10.5858L17.2427 5.34315C17.6332 4.95262 18.2663 4.95262 18.6569 5.34315Z",
		fill: "currentColor"
	})
});
export default SvgXClose;
